import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  getInitialTranslationResources,
  inMemoryLangCache,
  refreshTranslationResources,
} from "./translationService";
import { staticFallbacks, translationNamespaces } from "./translationResources";

const getSavedLanguage = () => {
  try {
    return sessionStorage.getItem("language") || "lt";
  } catch (error) {
    return "lt";
  }
};

export function initializeI18n() {
  const currentLang = getSavedLanguage();
  const initialResources = getInitialTranslationResources(currentLang);

  i18n.use(initReactI18next).init({
    fallbackLng: "lt",
    lng: currentLang,
    ns: translationNamespaces,
    defaultNS: "home",
    resources: { [currentLang]: initialResources },
    interpolation: {
      escapeValue: false,
    },
    partialBundledLanguages: true,
  });

  inMemoryLangCache[currentLang] = true;
  refreshTranslationResources(i18n, currentLang);
}

initializeI18n();

export default i18n;
export { staticFallbacks };
